import { v4 as generateUuidV4 } from 'uuid'

export function generateHash(): string {
  return generateUuidV4()
}
